import styled from 'styled-components';

import { HERO_FONT_BODY, LandingHero } from 'constants/landing-hero';

export const Row = styled.div`
  margin-top: 4.8rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem 2.2rem;
  font-family: ${HERO_FONT_BODY};
  font-size: 1.4rem;
  font-weight: 600;
  color: ${LandingHero.trustText};
`;

export const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
`;
